import { render, staticRenderFns } from "./ExitList.vue?vue&type=template&id=2a5ecc96"
import script from "./ExitList.vue?vue&type=script&lang=js"
export * from "./ExitList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports